import { splitHometown, stateAbbr } from "../../../../utils/hometown";

// Hometown capture: the city goes in homeTown and the state in its own
// field (a state code, or an abbreviation the server resolves). Athletes
// often type the state into the city box ("Chandler, AZ"); when they leave
// the box, a state suffix moves into an empty State picker. Used by the
// onboarding details step and the edit hub.

const hasValue = (v) => v !== undefined && v !== null && String(v).trim() !== "" && String(v).trim() !== "0";

// A codes-style map ({state: {code: row}}) from the picker's rows, so the
// shared helper can read a code's abbreviation.
const codeMapOf = (options = []) => ({
  state: Object.fromEntries((options || []).filter((o) => o && o.value != null).map((o) => [o.value, o])),
});

const upper = (v) => String(v || "").trim().toUpperCase();

// 'AZ' for a code, an abbreviation or a state name; '' when unknown.
export const abbrOf = (value, options = []) => {
  if (!hasValue(value)) return "";
  const row = (options || []).find((o) => o && String(o.value) === String(value).trim());
  if (row) return upper(row.options?.abbr) || abbrOf(row.name);
  try {
    return upper(stateAbbr(value, codeMapOf(options)));
  } catch {
    return /^[A-Za-z]{2}$/.test(String(value).trim()) ? upper(value) : "";
  }
};

// The picker row for an abbreviation or a state name.
export const findStateOption = (value, options = []) => {
  const want = abbrOf(value);
  const text = String(value || "").trim().toLowerCase();
  if (!want && !text) return null;
  return (options || []).find((o) => {
    if (!o) return false;
    const rowAbbr = upper(o.options?.abbr) || abbrOf(o.name);
    return (want && rowAbbr === want) || String(o.name || "").trim().toLowerCase() === text;
  }) || null;
};

// When the typed hometown ends in a US state: the fields to change, or null.
// - State picker empty: keep the city, fill the picker with that state.
// - Picker already on the same state: keep the city, drop the repeat.
// - Picker on another state: leave the text as typed.
export const splitCityOnBlur = (raw, currentState, options = []) => {
  const text = String(raw || "");
  if (!text.trim()) return null;
  let parts;
  try { parts = splitHometown(text) || {}; } catch { return null; }
  const city = String(parts.city || "").trim();
  const typed = abbrOf(parts.state);
  if (!city || !typed || city === text.trim()) return null;
  if (!hasValue(currentState)) {
    const row = findStateOption(typed, options);
    return row ? { homeTown: city, state: row.value } : null;
  }
  return abbrOf(currentState, options) === typed ? { homeTown: city } : null;
};

// Picker rows for when the state codes are not loaded: the server resolves
// an abbreviation to its code.
export const abbrStateOptions = (abbrs) => abbrs.map((ab) => ({ value: ab, name: ab, options: { abbr: ab } }));
